/* Regenis cart-drawer v23 (Vitro-style).
   v23 (2026-07-15): timer NEVER hides -- restarts at expiry; duration from
   data-rg-dur/data-duration; writes into the .rg-timer span (label preserved).
   v22 (2026-07-10): stuck scroll-lock fix. The v21 lock released via a
   MutationObserver on the cart-drawer NODE; the theme editor replaces that node
   on every section re-render, so if the drawer was open (or selected in the
   editor) when the swap happened, the observer died on the detached node and
   body position:fixed / overflow:hidden never cleared -- page alive (timers,
   marquee animating) but unscrollable. Empirically reproduced: add .active,
   replaceWith(clone without .active) -> body stays fixed forever. The lock is
   now owned by a 200ms reconciler that derives desired state from the LIVE DOM
   (any cart-drawer.active present?) and balances exactly one lock/unlock pair,
   so it survives arbitrary node replacement. No mutation noise: it writes
   nothing unless the state actually flips.
   v21 (2026-07-09): freeze fix. The v20 body MutationObserver ran its whole work
   bundle (querySelectorAll + full-subtree textContent reads + offsetHeight forced
   layout) SYNCHRONOUSLY on every DOM mutation anywhere on the page, and the
   reservation timer / vvApply wrote identical values every tick -- each no-op
   write still queues mutation records and style recalcs that fan out to every
   observer on the page (Clarity, Kaching, pixel, rgx-upsell). Together with the
   upsell sync loop this froze the storefront AND the theme editor. Now: (a) the
   body observer ignores records from the timers and pill holders and defers all
   work behind one 150ms trailing debounce; (b) the timer only writes digits that
   changed; (c) syncProgressState only toggles when the class state differs;
   (d) vvApply only styles the drawer while it is open and only when the value
   actually changed. Behavior is pixel-identical; the idle page is now silent.
   v20: OWN slide-up reveal for the sticky bar -- the theme's reveal transition is
   dead (frozen animation clock) so the bar snapped in stagey paints; a class/
   style observer now catches the show-toggle in the same frame (before paint),
   re-hides the bar inline, then interval-animates translateY -> 0 over 200ms
   eased. One owner, one fluid motion. v19: instant --rgx-sbh via Resize/attr
   observers + 10px drop. v18: svh top-anchor vs the iOS 26 fixed-bottom paint
   bug (webkit.org/b/297779). */
(function () {
  var KEY = 'rgxCartTimerV2';
  var DONE = 'rgxCartTimerDoneV2';
  var bodyT = null;

  if (!window.rgxScrollLock) {
    window.rgxScrollLock = (function () {
      var n = 0, y = 0;
      function lock() {
        if (++n !== 1) return;
        y = window.scrollY || window.pageYOffset || 0;
        var b = document.body;
        b.style.position = 'fixed';
        b.style.top = (-y) + 'px';
        b.style.left = '0';
        b.style.right = '0';
        b.style.width = '100%';
        b.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }
      function unlock() {
        if (n === 0) return;
        if (--n > 0) return;
        var b = document.body;
        b.style.position = '';
        b.style.top = '';
        b.style.left = '';
        b.style.right = '';
        b.style.width = '';
        b.style.overflow = '';
        document.documentElement.style.overflow = '';
        try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
      }
      return { lock: lock, unlock: unlock };
    })();
  }

  function injectStyles() {
    /* Icon font is self-hosted via theme.liquid @font-face (rg-msym-outlined.woff2);
       no external stylesheet needed. */
    if (document.getElementById('rgx-cart-css')) return;
    var s = document.createElement('style');
    s.id = 'rgx-cart-css';
    s.textContent =
      '#PBarNextFrameWrapper,#preview-bar-iframe,iframe[id*="PBar"],iframe[src*="preview_bar"],[id*="PreviewBar"]{display:none !important;}' +
      'body:has(#PBarNextFrameWrapper),body:has(#preview-bar-iframe),body:has(iframe[src*="preview_bar"]){padding-bottom:0 !important;}' +
      '.cart-timer{background:#C47245 !important;color:#ffffff !important;border:none !important;border-radius:0 !important;margin:0 -1.5rem 0.4rem !important;padding:1.15rem 1.5rem !important;display:block;text-align:center;font-weight:400;opacity:0;}' +
      '.cart-timer.rgx-live{opacity:1;transition:opacity .12s ease;}' +
      '.cart-timer strong{color:#ffffff !important;font-weight:700;}' +
      '[class*="material-symbols"]{font-family:"Material Symbols Outlined" !important;font-weight:normal;font-style:normal;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;font-feature-settings:"liga";}' +
      '[class*="material-symbols"].filled{font-variation-settings:"FILL" 1;}' +
      '.drawer__heading{font-size:1.9rem !important;letter-spacing:.05em;}' +
      'html:has(cart-drawer.active),body:has(cart-drawer.active){overflow:hidden !important;}' +
      'cart-drawer .drawer__inner,cart-drawer .cart-drawer__body,cart-drawer .drawer__contents{overscroll-behavior:contain;}' +
      '@supports (height: 100dvh){cart-drawer.drawer{height:100dvh;}}' +
      '@media (max-width: 749px){cart-drawer.drawer.active{background:#ffffff;width:100vw !important;left:0 !important;right:auto !important;}cart-drawer.drawer.active .drawer__inner{width:100% !important;max-width:100% !important;}}' +
      'cart-drawer .drawer__inner{position:relative;height:100% !important;max-height:100% !important;}' +
      'cart-drawer .drawer__footer{padding-bottom:calc(1.2rem + env(safe-area-inset-bottom)) !important;}' +
      '.upsell__content{min-width:0;flex:1 1 auto;}' +
      '.upsell__title h3{word-break:normal;overflow-wrap:normal;hyphens:none;font-size:1.4rem;line-height:1.3;margin:0;}' +
      '.upsell__desc{font-size:1.25rem;line-height:1.4;}' +
      '.upsell__outside-title{color:#7D2929 !important;font-weight:700 !important;text-decoration:underline;text-underline-offset:3px;text-align:center !important;letter-spacing:.01em;}' +
      '.upsell__toggle-switch{width:4rem;height:2rem;min-width:4rem;border-radius:2rem;border:none;position:relative;cursor:pointer;padding:0;transition:background .2s ease-in-out;flex:0 0 auto;-webkit-tap-highlight-color:transparent;outline:none;}' +
      'cart-drawer .upsell__toggle-switch, cart-drawer [data-selected] .upsell__toggle-switch, cart-drawer [data-selected="true"] .toggle-switch{background:#d5d5d5 !important;}' +
      '.upsell__toggle-switch .toggle-switch__slider{position:absolute;top:50%;width:1.7rem;height:1.7rem;border-radius:50%;background:#ffffff;box-shadow:none;transform:translate(-50%,-50%);transition:left .3s ease-in-out;display:block;}' +
      'cart-drawer .upsell__toggle-switch .toggle-switch__slider, cart-drawer [data-selected="true"] .toggle-switch .toggle-switch__slider{left:1rem !important;}' +
      'cart-drawer .upsell__toggle-switch.rgx-on{background:#C47245 !important;}' +
      'cart-drawer .upsell__toggle-switch.rgx-on .toggle-switch__slider{left:calc(100% - 1rem) !important;}' +
      '#rvsticky,.rvsticky{top:auto !important;bottom:0 !important;padding-bottom:env(safe-area-inset-bottom);}' +
      '@supports (top: 1svh){#rvsticky,.rvsticky{top:calc(100svh - var(--rgx-sbh, 9rem) + 10px) !important;bottom:auto !important;}}' +
      '.rvsticky::after{content:"";position:absolute;top:100%;left:0;right:0;height:220px;background:#ffffff;}' +
      'body:has(cart-drawer.active) .rvsticky{transform:translateY(110%) !important;pointer-events:none;}' +
      '.cart-progress__bar__badge{transition:border-color .2s,color .2s;}' +
      '.cart-checkpoints__label{left:50%;transform:translateX(-50%);color:rgba(var(--color-foreground),.9);}' +
      'cart-drawer [name="checkout"]{letter-spacing:.02em;}';
    document.head.appendChild(s);
  }

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function slideIn(sb) {
    if (sb.__rgxSliding) return;
    sb.__rgxSliding = true;
    var h = sb.offsetHeight || 90;
    sb.style.setProperty('transform', 'translateY(' + h + 'px)', 'important');
    var t0 = Date.now();
    var iv = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / 200);
      var y = Math.round((1 - easeOut(p)) * h);
      if (p >= 1) {
        clearInterval(iv);
        sb.style.removeProperty('transform');
        sb.__rgxSliding = false;
      } else {
        sb.style.setProperty('transform', 'translateY(' + y + 'px)', 'important');
      }
    }, 16);
  }

  function readShown(sb) {
    try {
      var tf = getComputedStyle(sb).transform;
      if (!tf || tf === 'none') return true;
      var m = new DOMMatrixReadOnly(tf);
      return Math.abs(m.m42) < (sb.offsetHeight || 90) * 0.5;
    } catch (e) { return true; }
  }

  function syncSbh() {
    var sb = document.getElementById('rvsticky');
    if (!sb) return;
    if (sb.style.bottom) sb.style.removeProperty('bottom');
    var h = sb.offsetHeight;
    if (h && h !== window.__rgxSbh) {
      window.__rgxSbh = h;
      document.documentElement.style.setProperty('--rgx-sbh', h + 'px');
    }
  }

  function sbObserve() {
    var sb = document.getElementById('rvsticky');
    if (!sb || sb.__rgxSbObs) return;
    sb.__rgxSbObs = true;
    syncSbh();
    sb.__rgxShown = readShown(sb);
    try { new ResizeObserver(syncSbh).observe(sb); } catch (e) {}
    try {
      new MutationObserver(function () {
        syncSbh();
        var now = sb.__rgxSliding ? true : readShown(sb);
        if (now && sb.__rgxShown === false && matchMedia('(prefers-reduced-motion: no-preference)').matches) slideIn(sb);
        sb.__rgxShown = now;
      }).observe(sb, { attributes: true, attributeFilter: ['class', 'style'] });
    } catch (e) {}
  }

  function vvApply() {
    var vv = window.visualViewport;
    var dr = document.querySelector('cart-drawer.drawer');
    /* v21: only pin the drawer to the visual viewport while it is open, and only
       write when the value actually changed -- identical no-op writes were
       queueing style mutations + recalcs every 600ms forever. */
    if (vv && dr && dr.classList.contains('active')) {
      var h = Math.round(vv.height) + 'px';
      var t = Math.round(vv.offsetTop) + 'px';
      if (dr.style.height !== h) dr.style.setProperty('height', h, 'important');
      if (dr.style.top !== t) dr.style.setProperty('top', t, 'important');
      if (dr.style.bottom !== 'auto') dr.style.setProperty('bottom', 'auto', 'important');
    }
    sbObserve();
    syncSbh();
  }

  function vvInit() {
    if (window.__rgxVV) return;
    window.__rgxVV = true;
    var vv = window.visualViewport;
    if (vv) {
      vv.addEventListener('resize', vvApply);
      vv.addEventListener('scroll', vvApply);
    }
    window.addEventListener('resize', vvApply);
    window.addEventListener('orientationchange', function () { setTimeout(vvApply, 250); });
    window.addEventListener('pageshow', function () { vvApply(); setTimeout(vvApply, 250); setTimeout(vvApply, 800); });
    window.addEventListener('load', function () { vvApply(); setTimeout(vvApply, 250); setTimeout(vvApply, 800); });
    vvApply();
    /* rg-perf 2026-07-18: was setInterval(vvApply, 600) forever, which read
       #rvsticky.offsetHeight every tick (forced synchronous layout 1.67x/sec for
       the life of the page). sbObserve() already attaches a ResizeObserver +
       MutationObserver to #rvsticky that call syncSbh on real change, so the poll
       was only useful to wait for that element to appear. Poll until the
       observers are attached, then stop. Capped so it can never run forever. */
    (function () {
      var tries = 0;
      var iv = setInterval(function () {
        vvApply();
        var sb = document.getElementById('rvsticky');
        if ((sb && sb.__rgxSbObs) || ++tries > 60) clearInterval(iv);
      }, 600);
    })();
  }

  /* v22: the lock is reconciled from live DOM state on a 200ms interval instead
     of observing one drawer node -- the editor replaces that node on section
     re-renders, which orphaned the old observer while it held the lock. This
     owns exactly one lock reference, flips only on real state changes (no idle
     writes), and any transient stuck state self-heals within 200ms. The
     html:has(cart-drawer.active) CSS rule covers the sub-200ms window. */
  function lockReconciler() {
    if (window.__rgxLockRec) return;
    /* rg-perf 2026-07-18: this polled querySelector('cart-drawer.active') 5x/sec
       forever. cart_type is "page" on this store, so <cart-drawer> is never
       rendered and the query can never match. Gate on the element existing at
       all -- if the cart type is ever switched back to drawer, the page reload
       that follows re-runs this and the reconciler starts normally. */
    if (!document.querySelector('cart-drawer')) return;
    window.__rgxLockRec = true;
    var cartLocked = false;
    setInterval(function () {
      var want = !!document.querySelector('cart-drawer.active');
      if (want === cartLocked) return;
      cartLocked = want;
      if (want) { window.rgxScrollLock.lock(); vvApply(); }
      else { window.rgxScrollLock.unlock(); }
    }, 200);
  }

  function syncProgressState() { return;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initTimer(scope) {
    var box = (scope || document).querySelector('.cart-timer');
    if (!box) return;
    if (box.__rgxTimer) return;
    box.__rgxTimer = true;
    box.style.display = '';   /* recover from any previously-hidden state */
    var ct = box.querySelector('.rg-timer') || box.querySelector('countdown-timer') || box;
    /* duration from the data attribute (the .rg-timer span renders empty, so
       text-parsing fell through to a 2-minute default) */
    var durAttr = parseInt((ct.getAttribute && (ct.getAttribute('data-rg-dur') || ct.getAttribute('data-duration'))) || '', 10);
    var m = (ct.textContent || '').match(/(\d{1,2})\s*:\s*(\d{2})/);
    var totalMs = durAttr ? (durAttr > 60 ? durAttr : durAttr * 60) * 1000
                : (m ? ((+m[1]) * 60 + (+m[2])) * 1000 : 300000);
    var deadline = 0;
    try { deadline = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
    if (!deadline || deadline <= Date.now()) {
      /* v22: stale/expired deadline -> start a fresh countdown this pageview */
      deadline = Date.now() + totalMs;
      try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }
    var spans = ct.querySelectorAll('span');
    /* v21: only write digits that changed -- a textContent assignment replaces
       the text node even when equal, which queued 2+ mutation records/second
       forever and kept every observer on the page busy. */
    function render(msLeft) {
      var s = Math.max(0, Math.round(msLeft / 1000));
      var mm = pad(Math.floor(s / 60)), ss = pad(s % 60);
      if (spans.length >= 2) {
        if (spans[0].textContent !== mm) spans[0].textContent = mm;
        var last = spans[spans.length - 1];
        if (last.textContent !== ss) last.textContent = ss;
      } else {
        var t = mm + ':' + ss;
        if (ct.textContent !== t) ct.textContent = t;
      }
    }
    function tick() {
      if (!document.contains(box)) { clearInterval(box.__rgxInt); return; }
      /* self-assert visibility every beat: any external attr write that strips
         .rgx-live would otherwise leave the banner ticking at opacity:0 */
      if (!box.classList.contains('rgx-live')) box.classList.add('rgx-live');
      if (box.style.display === 'none') box.style.display = '';
      var left = deadline - Date.now();
      if (left <= 0) {
        /* v23: RESTART in place -- hiding at expiry was the vanishing
           "Cart reserved" banner. The scarcity loop just begins again. */
        deadline = Date.now() + totalMs;
        try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
        left = totalMs;
      }
      render(left);
    }
    tick();
    if (!box.classList.contains('rgx-live')) box.classList.add('rgx-live');
    if (box.__rgxInt) clearInterval(box.__rgxInt);
    box.__rgxInt = setInterval(tick, 1000);
  }

  /* v21: records from the timers / pill holders / read bar are ignored, and all
     work is deferred behind one trailing debounce instead of running
     synchronously per mutation (initTimer's re-attach, the progress scan and the
     sticky-bar observe all tolerate 150ms). */
  var IGNORE_SEL = '.cart-timer, .rgx-deal-pills, .rgx-sale-pills, #rgx-readbar, [class*="rg_countdown_timer_box_"]';
  function bodyWork() {
    initTimer(document);
    syncProgressState();
    lockReconciler();
    sbObserve();
    injectStyles();
  }

  function init() {
    injectStyles();
    vvInit();
    lockReconciler();
    initTimer(document);
    syncProgressState();
    if (!document.body.__rgxTimerObs) {
      document.body.__rgxTimerObs = true;
      new MutationObserver(function (muts) {
        var rel = false;
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          var el = t.nodeType === 1 ? t : t.parentElement;
          if (el && el.closest && el.closest(IGNORE_SEL)) continue;
          rel = true; break;
        }
        if (!rel) return;
        clearTimeout(bodyT);
        bodyT = setTimeout(bodyWork, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

